import { useSites } from '@/lib/queries';
import { WidgetFrame } from '@/pages/home/widgets/WidgetFrame';

/**
 * 전 현장 집계. 현장 정보({@link '/sites/status'})의 요약 카드를 그대로 홈에 올린다.
 *
 * 숫자 정의는 현장 정보와 한 곳에서 나와야 한다 — 위젯이 자기만의 셈을 갖게 되면 홈과 현장 정보가
 * 다른 숫자를 내는 날이 온다. 그래서 전체·사용중·진행·평가·미진행·준공 여섯 값을 현장 정보와 같은
 * 기준으로 센다.
 */
export function SiteSummaryWidget() {
  const sites = useSites();
  const all = sites.data ?? [];

  const summary = {
    total: all.length,
    active: all.filter((site) => site.active).length,
    progressing: all.filter((site) => site.status === '진행').length,
    evaluating: all.filter((site) => site.status === '평가').length,
    pending: all.filter((site) => site.status === '미진행').length,
    completed: all.filter((site) => site.status === '준공').length,
  };

  return (
    <WidgetFrame
      title="현장 현황"
      icon="chart"
      to="/sites/status"
      pending={sites.isPending}
      error={sites.error}
      empty={all.length === 0}
      emptyText="등록된 현장이 없습니다."
    >
      <div className="grid grid-cols-2 gap-2">
        <Tile label="전체 현장" value={summary.total} tone="primary" />
        <Tile label="사용 중" value={summary.active} tone="accent" />
      </div>

      <div className="grid grid-cols-4 gap-2 mt-2">
        <Tile label="진행" value={summary.progressing} tone="accent" />
        <Tile label="평가" value={summary.evaluating} tone="accent" />
        <Tile label="예정" value={summary.pending} tone="muted" />
        <Tile label="준공" value={summary.completed} tone="green" />
      </div>
    </WidgetFrame>
  );
}

function Tile({ label, value, tone }: { label: string; value: number; tone: 'primary' | 'accent' | 'green' | 'muted' }) {
  const color =
    tone === 'primary'
      ? 'var(--text-primary)'
      : tone === 'accent'
        ? 'var(--accent)'
        : tone === 'green'
          ? '#15803d'
          : 'var(--text-muted)';

  return (
    <div className="px-2 py-2 rounded-lg text-center" style={{ background: 'var(--bg-hover)' }}>
      <p className="font-bold text-ui-xl" style={{ color }}>
        {value}
      </p>
      <p className="text-ui-xs" style={{ color: 'var(--text-muted)' }}>{label}</p>
    </div>
  );
}
